export default {
    site: {
        common: {
            hello: "Hej",
            thankYou: "Tak",
            forMoreInfo: "for mere info",
            hoverOverColumnHeaders: "hold musen over overskrifter for mere information.",
            username: "brugernavn",
            score: "Score",
            points: "Point",
            pointsAbbreviation: "pt",
            chapter: "Kapitel",
            tier: "Kategori",
            t1: "K1",
            t2: "K2",
            t3: "K3",
            collectionsPerDay: "Indsamlinger pr dag",
            relicBoostPercent: "Relikvieboost %",
            mountainHallPercentShort: "Bjergrådh. %", // used in table heading keep it short.
            updated: "opdateret",
            lastUpdated: "Sidst opdateret",
            created: "oprettet",
            role: "rolle",
            Fellow: 'Medlem',
            Ambassador: 'Ambassadør',
            Mage: 'Magiker',
            Archmage: 'Leder',
            saveChanges: "Gem ændringer",
            copy: "Kopier",
            close: "Luk",
            cancel: "Anuller",
            action: "Handling",
            date: "Dato",
            Left: "Forlod broderskabet",
            Joined: "Blev medlem",
            human: "Menneske",
            elf: "Elver",
            search: "Søg",
            enter: "Skriv",
            yes: "Ja",
            no: "Nej",
            tournament: "Turnering",
            tournaments: "Turneringer",
            fellowship: "Broderskab",
            player: "Spiller",
            member: "Medlem",
            history: "Historik",
            tournamentHistory:  "Turneringshistorik",
            scoreHistory: "Score Historik",
            server: "Server",
            lastWeekGain: "Fremskridt seneste uge",
            comingSoon: "Kommer snart",
            chest: "kiste",
            yourServer: "Dine servere",
            allServers: "Alle servere",
            boosts: "Boosts",
            marble: "marmor",
            steel: "stål",
            planks: "planker",
            crystal: "krystal",
            scrolls: "skriftruller",
            silk: "silke",
            elixir: "eliksir",
            magic_dust: "magisk støv",
            gems: "juveler",
            sentient: "besjælede",
            goods: "varer",
            average: "gennemsnitlig",
            expansions: 'Udvidelser', // 5x5 grids
            cultureBoostMinimum: 'Kulturboost, min',
            cultureBoostCalculated: 'Kulturboost, beregnet',
            neighborlyHelp: 'Nabohjælp',
            neighborlyHelpAbbreviation: 'NH'
        },
        // HIGH PRIORITY
        nav: {
            home: "Hjem",
            players: "Spillere",
            fellowships: "Broderskaber",
            tournaments: "Turneringer",
            contact: "Kontakt",
            donate: "Doner",
            faq: "FAQ",
            news: "Nyheder",
            privacyPolicy: "Politik for privatliv",
            me: "Mig",
            myFellowship: "Mit broderskab",

            // NOTE USED AT THE MOMENT
            globalStats: "Globale statistikker",
            articles: "Artikler",
            fellowshipAdventure: "Broderskabets eventyr",
            recruit: "Rekrutter",
        },
        // VERY HIGH PRIORITY!
        elvenArchitect: {
            viewCityOnElvenArchitect: "Vis by på ElvenArchitect"
            ,obtainingLink: "Henter Link"
            ,successMessage: "Succes! Klik på nedenstående link for at åbne ElvenArchitect"
            ,ageOfLink: "Ovenstående link vil vise byen som den så ud: "
            ,clickToGetCurrentCity: "<-- Klik for at hente den aktuelle by",
        },
        // High Priority
        playerSelection: {
            headline: "Vis siden som",
            description: "Dette vil opdatere forskellige dele af siden som er tilpasset brugeren.  For eksempel: Mit broderskab, Min bruger, Turneringer, og ranglister.",
            youAreViewing: `Du ser nu siden som {username} på {serverName}.`,
            changeUser: "Skift spiller",
            enterYourUsernameToGetStarted: "Skriv dit Elvenar brugernavn for at begynde",
            thisIsNotASignup:"Dette er ikke en registreringsproces.  Ved at skrive dit brugernavn, tilpasser vi blot siden.  Der er mange Elvenar servere og vi vil vise ranglister for din server.  Også dit broderskab og links til din personlige brugerside vil være tilgængelige."
        },
        searchBoxes: {
            enterFellowshipName: 'Skriv navn på broderskab',
            instructions: "Skriv navnet og vælg.",
            noFellowship: "Intet broderskab",
        },
        relativeTime: {
            // Relative time strings - note: these aren't yet implemented in the code
            daysAgo: "dage siden",
            minsAgo: "minutter siden",
            hoursAgo: "timer siden",
            justNow: "Nu",
            never: "Aldrig",
        },
        home: {
            welcome: "Velkommen til Elven Stats!",
            youAreViewing: "Du ser nu siden som {username} på {serverName}",
            youCanChange: "Du kan skifte bruger ved at klikke på avataren øverst til højre -eller- ved at <router-link to='/contact'>besøge denne side</router-link>",
            features: {
                headline: "Funktioner",
                fellowshipAdministration: {
                    headline: "<strong>Let</strong> administration af broderskab",
                    bullet1: "Automatisk registrering af boostede varer - lettere balancering af dit broderskab",
                    bullet2: "Automatisk dannelse af ugentlige emails med rapporter inkl. point, deltagelse i turneringer, månedlig vækst, motiverende \"anerkendelser\" og personlige rekorder",
                    bullet3: "Hjælp til at identificere ubalancer i produktionen hos broderskabets medlemmer såsom forsyninger eller forkert forhold mellem produktion af varekategorier",
                },
                elvenArchitectIntegration: {
                    headline: "ElvenArchitect <strong>integration</strong>",
                    description: "Hent din by ind i ElvenArchitect præcis som den ser ud - på få sekunder! Brug dette for bedre at planlægge din næste store omorganisering af byen eller for at finde plads du ikke var klar over du havde! Se efter ElvenArchitect logoet på spillersiderne."
                },
                advancedRankingLists: {
                    headline: "Avancerede <strong>ranglister</strong>",
                    bullet1: "Rangliste sorteret efter antal åbne områder (for at sammenligne dig selv med andre spillere på samme stadie)",
                    bullet2: "Se boosts, kapitel med mere i spillerlister.",
                },
                fellowshipTournamentTracking: {
                    headline: "<strong>Følg</strong> broderskabets turneringer",
                    description: "Se hvordan dit broderskab klarer sig i forhold til andre. Udfordring af andre broderskaber til en venskabelig kappestrid!",
                },
                matchMaking: {
                    headline: "Find <strong>egnede</strong> kandidater",
                    description: "ElvenStats sporer spilleres boosts og fordelingen af vareproduktion i broderskaber.  Med denne information, kan broderskaber rekruttere de rigtige kandidater for at balancere deres varer. Brugere, der søger et broderskab, kan finde et, der faktisk BEHØVER deres boosts. Dette sparer tid og reducerer risikoen for afvisning!"
                }
            }
        },
        fellowship: {
            stats: {
                rank: "Rang",
                points: "Point",
                medianUserScore: "Middel<strong>brugerscore</strong>",
                memberCount: "<strong>Antal</strong> medlemmer",
            },
            barCharts: {
                clickSlice: "Klik på en søjle for detaljer (pr. medlem)",
                tier1: "Kategori 1",
                tier2: "Kategori 2",
                tier3: "Kategori 3",
                drillDown: "Tilbage til {0}"
            },
            idealCandidate: {
                heading: "Ideel Kandidat",
                description: "Har en score omkring {medianScore} og har en eller flere af følgende boosts: {boosts}",
                note: "Nogle kombinationer af boosts er ikke mulige. Se {0}"
            },
            memberGoodsTable: {
                heading: "Medlemmers vareproduktion",
                description: `Denne tabel beregner hvor meget af hver vare, dit broderskab producerer. Vi har brugt et kvalificeret gæt på hvad de respektive medlemmers boostprocenter var og som udgangspunkt antager vi at hvert medlem indsamler produktioner 3 gange om dagen
                (2x9h and 1x3h). For at forbedre præcisionen, kan du spørge broderskabets medlemmer om deres faktiske værdier. 
                Du kan gemme det du indtaster, så det bliver vist næste gang du indlæser denne side. Søjlediagrammerne ovenfor vil opdateres automatisk når du laver ændringer. 
                Hold musen over en kolonneoverskrift for mere information om den enkelte kolonne.`,
                refreshButtonText: 'Indlæs medlemsliste',
                refreshButtonTip: 'Dette vil tilføje nye medlemmer, fjerne tidligere medlemmer, opdatere roller i broderskabet, og opdatere scores.',
                inactiveWarningTip: 'Brugeren er muligvis inaktiv, score blev sidst opdateret: {0}',
                collectsPerDayValidation: "Skal være mellem 1 og 6",
                boostPercentValidation: "Skal være mellem 40 og 700, bonus fra bjergrådhus skal ikke inkluderes",
                perDayShort: "/dag",

                // HIGH PRIORITY - IMPORTANT TOOLTIPS
                scoreTip: "Spillerens score, bemærk at detnne ikke opdateres løbende.  Opdateres flere gange om ugen.",
                chapterTip: "Det kapitel hver spiller befinder sig i.  For reference: Elementrånder = 12, Halvinger = 11, etc.",
                boostTip: "Spillerens boost og mængde produceret per dag.",
                collectsPerDayTip: `***KAN REDIGERES*** <br/>Indsamlinger per dag. Antallet a gange per dag brugeren indsamler varer fra deres fabrikker. Kan have en værdi mellem 1 og 6.  1 = 1x24h, 2=2x9h, 3=2x9h + 1x3h, 4=1x9h + 3x3h, 5=4x3h + 1x9h, 6=5x3h + 1x9h<BR/>Se venligst FAQ for detaljer.`,
                relicBoostPercentTip: `***KAN REDIGERES***<br/>Boostprocenten fra relikvier, mellem 40 og 700.  Tallet skal ikke inkludere procenten fra Bjergrådhuset. Denne findes automatisk og lægges til dette tal`,
                mountainHallPercentTip: "Procenten fra Bjergrådhus vi har fundet for denne bruger. Bruges sammen med boostprocenter for at beregne den totale boostpercent.",
                updatedTip: "Dette viser hvornår spillerens by sidst blev analyseret. Denne proces beregner boosts, data til ElvenArchitect, produktion fra alle fabrikker, procent fra bjergrådhuset, med mere. Data fra bykortet hentes periodisk, men du kan starte en opdatering ved at klikke på knappen \"Opdater\" herunder.",

            },
            coinsAndSuppliesTable: {
                heading: "Produktion af mønter/forsyninger",
                description: `Den vigtigste kolonne her er "Forsyninger til rådighed" da denne viser om et medlem vil producere forsyninger nok til at holde deres fabrikker i gang 24/7. 
                Brug knapperne herunder for at ændre om beregningen medtager spillers minimum kulturboost (boost hvis byen ikke får nabohjælp)
                og/eller antallet af gange spilleren indsamler per dag (som angivet i tabellen "Medlemmers vareproduktion" ovenfor).  Slå begge fra hvis du vil se andelen af forsyninger, 
                der kommer fra flere værksteder eller en højere kulturboost. Bemærk også at det ikke er usædvanligt at have en lille negativ ( omkring 10% af totalen) mængde forsyninger til rådighed. Der er mange måder spillere kan 
                supplere deres forsyninger såsom nabohjælp, fremstilling af forsyninger med kortere intervaller (Drikkevarer, Simple redskaber, Brød...) eller ved at bruge Forsyningernes styrke formularer.
                Tænke på den negative værdi som det du er nødt til at indhente på daglig basis ved brug af disse muligheder.
                BEMÆRK: på nuværende tidspunkt medtages træning af tropper ikke i beregningen af brugte forsyninger (kun kategori 1, 2 og 3 varer) så du har muligvis brug for flere.`,

                // These are the column text that show up under the icons. Keep them short.
                minBoostPercent: "Min. boost %",
                made: "Fremstillet",
                used: "Brugt",
                left: "Til rådighed",

                // Low Priority TOOL TIPS
                minimumCultureBoostPercent: "Kulturboost procenten.  VIGTIGT: beregningen medtager INGEN NABOHJÆLP til kulturbygninger. I virkeligheden vil denne sandsynligvis være højrere i din by",
                moneyComputedTip: "Antallet af mønter der fremstilles på en dag, inkluderer vidundere der producerer mønter",
                moneyUsedComputedTip: "Antallet af mønter, der bruges på at fremstille varer",
                moneyRemainingComputedTip: "Mønter fremstillet - mønter brugt, overskud/underskud af mønter en spiller har hver dag",
                suppliesComputedTip: "Forsyninger produceret hvis alle værksteder var sat til 24x1 (Værktøjskasser) + evt. vidundere (inkluderer ikke sætbonuser)",
                suppliesUsedComputedTip: "Forsyninger brugt ved fremstilling af varer. Inkluderer ikke forsyninger brugt ved træning af tropper! Se forklaringen ovenfor",
                suppliesRemainingComputedTip: "Forsyninger fremstillet - forsyninger brugt, overskud/underskud af forsyninger en spiller har hver dag",
                manaTip: "Mængden af Mana produceret på 24 timer (inkluderer ikke Drageklosteret)",
            },
            popCultureTable: {
                heading: "Detaljer for befolkning/kultur",
                description: 'Nedenstående tabel viser befolkning/kultur for hvert medlem. Hold musen over overskrifter for mere information.',

                // Icon Sub-Headings
                minBoostPercent: "Min. boost %",
                levels: "Niveauer",
                total: "Total",
                working: "I arbejde",
                available: "Tilgængelig",
                required: "Krævet",

                // Low Priority - Tool Tips
                wonderLevelsTip: "Det samlede antal niveauer for vidundere en spiller har",
                cultureBoostPercentTip: "Kulturboost procenten.  VIGTIGT: beregningen medtager INGEN NABOHJÆLP til kulturbygninger. I virkeligheden vil denne sandsynligvis være højrere i din by",
                totalPopulationTip: "Total befolkning fra boliger, kultur/befolkning hybrid bygninger og vidundere",
                workingPopulationTip: "Befolkning i arbejde - Antal indbyggere brugt i bygninger",
                availablePopulationTip: "Befolkning tilgængelig",
                totalCultureTip: "Total kultur fra kulturbygninger, kultur/befolkning hybrid bygninger og vidundere",
                requiredCultureTip: "Kultur krævet for alle bygninger",
                availableCultureTip: "Kultur tilgængelig",
            },
            cityCoverageTable: {
                heading: "Pladsforbrug",
                description: "Viser hvor mange felter der bruges i hvert medlems by for hver bygningstype. Tomme felter er felter, der ikke benyttes i øjeblikket.",
                tiles: 'Felter'
            },

            // HIGH PRIORITY TO TRANSLATE
            weeklyReport: {
                heading: "Ugentlig emailrapport",
                description: "Vi genererer automatisk ugentlige rapporter der kan deles med dit broderskab. En ugentlige vil være tilgængelig hver søndag (omkring kl. 20 UTC) for den foregående uge. Teksten kopieres blot og sættes ind i en mail!",
                selectReportHint: "Vælg rapport for ugen der ender...",
                reportsAreOptimizedFor: "Emailrapporter er optimeret til visning i Elvenars beskedsystem så kolonner flugter bedst muligt og brugernavne forkortes så rapporten passer i en enkelt besked.",
                accolades: "anerkendelser",
                tourneyChamp: " - Turneringsmester (denne uge): {0}",
                tourneyHero: " - Turneringshelt (seneste 4 uger): {0}",
                highestGrowthPlusPercentage: " - Største vækst (point & procentvis): {0}",
                highestGrowthPoints: " - Største vækst (point): {0}",
                highestGrowthPercentage: " - Største vækst (procentvis): {0}",
                highestGrowthError: " - Største vækst: Kan ikke beregnes endnu, historik mangler",
                newPersonalRecords: "Nye personlige rekorder",
                userSetANewPersonalRecordFor: " * {0} satte en ny personlig rekord for: {1}",
                allMembersByPointGainThisWeek: "ALLE MEDLEMMER efter vækst i point / procent (denne uge)",
                tournamentPointsHeader: "TURNERINGSPOINT (denne uge / TOTAL SIDEN {0})",
                top8ByPercentage: "TOP 8 efter procentvis vækst (denne uge)",
                top8ByPointsSince: "TOP 8 efter point (siden {0})",
                top8ByPercentageSince: "TOP 8 efter procentvis vækst (siden {0})",
                reportGeneratedBy: "Rapporten er genereret af elvenstats.com, for mere se: ",
                mostPointsInAWeek: "Flest point på en uge",
                highestTournamentScore: "Højeste turneringsscore",
                highestTournamentRank: "Højeste turneringsplacering",
                insufficientHistoryForThesePlayers: "* Udeladt: {0} grundet manglende historik.  De vil blive inkluderet næste uge.",
                insufficientHistory1Week: "* Manglende historik for denne sektion. Check næste uges rapport!",
                insufficientHistory4Weeks: "* Manglende historik for denne sektion. 4 ugers historik kræves. Check igen snart!",
            },
            memberHistory: {
                heading: "Medlemshistorik",
                noChangesDetected: "Ingen ændringer noteret siden registrering af broderskaber startede {0}"
            },
            // Medium Priority
            notifications: {
                unsavedChanges: 'Du har ændringer der ikke er gemt. Klik på knappen "Gem ændringer" når du er færdig med at redigere dit broderskab.',
                standbyImporting: 'Vent venligst: Vi importerer manglende information for broderskabets medlemmer',
                limitedHistory: "Vi er først for nylig begyndt at følge denne {0} så der er begrænset historik.  Ugentlige snapshots vil kunne ses her hver søndag, så kom snart igen!",
                noChangesSinceTrackingBegan: "Ingen ændringer siden vi begyndte registrering.",
            }
        },
        player: {
            fellowshipHistory: {
                heading: "Historik for broderskaber"
            }
        },
        status: {
            realTimeUpdatesNotAvailableHeadline: "Løbende opdateringer er p.t. ikke tilgængelige.",
            realTimeUpdatesNotAvailableDescription: "Dette sker typisk efter at Elvenars Servere e genstartet i forbindelse med en opdatering eller vedligeholdelse. Når dette sker, er ElvenStats nødt til manuelt at logge ind på alle serverne før information kan hentes. Prøv venligst igen om et par timer. Bortset fra dette er ElvenStats fuldt funktionel.",
            copyToClipboardSuccessful: "Kopiering lykkedes !",
            copyToClipboardFailed: "Kopiering fejlede, marker hele teksten og tryk Ctrl+C",
            errorOccurredImporting: "Der skete en fejl under import af brugere.",
            errorOccurredImportingMessage: "Der skete en fejl under import af brugere. Prøv venligst igen. Kontakt os venligst hvis fejlen fortsætter.",
            errorOccurredImportingWillNotBeAvailableInReports: "Brugere, der ikke er importeret, vil ikke blive inkluderet i rapporter.",
            finishedSyncSuccessful: "Færdig, synkronisering lykkedes!",
            playerIsAnonymous: "Spilleren har bedt om at vedkommendes information ikke vises på elvenstats.com",
            inactiveWarningTip: "Spilleren er muligvis inaktiv.  Score har sidst ændret sig: {0}",
            isFriendTip: "Denne spiller er en ven af ElvenStats.  Vedkommende har doneret tid eller penge til støtte for siden!",
        }
    }
}


// WEBPACK FOOTER //
// ./src/lang/dk.js